(function($){
	$.fn.serializeObject = function(){
		const array = $(this).serializeArray();
		const obj = {};

		array.forEach(prop => {
			const isArray = Array.isArray(obj[prop.name]);

			if (obj[prop.name] && !isArray) {
				obj[prop.name] = [obj[prop.name]];
			} 

			if (isArray) {
				obj[prop.name].push(prop.value);
			} else {
				obj[prop.name] = prop.value;
			}
		});

		return obj;
	};
})(jQuery);
